import { useLocation } from 'react-router-dom';
import useSharedApps from '../../sitecoreContext/useSharedApps';
import { BUILD_AND_PRICE_URL } from '../../constants';
/**
 * This function returns the bap url if on bap page
 * @returns {Object}
 */
const useBapModelPageRoute = () => {
    var _a, _b, _c;
    const { pathname } = useLocation();
    const bapURL = useSharedApps(BUILD_AND_PRICE_URL);
    const defaultResponse = { isBapPage: false, bapModelURL: '' };
    // ignore the lang in url
    const pathWithoutLang = new Set((_b = (_a = pathname === null || pathname === void 0 ? void 0 : pathname.split('/')) === null || _a === void 0 ? void 0 : _a.slice(1, 3)) !== null && _b !== void 0 ? _b : []);
    const bapURLWithoutLang = ((_c = bapURL === null || bapURL === void 0 ? void 0 : bapURL.split('/')) !== null && _c !== void 0 ? _c : []).at(-1);
    if (!bapURLWithoutLang)
        return defaultResponse;
    if (!pathWithoutLang.has(bapURLWithoutLang))
        return defaultResponse;
    return { isBapPage: true, bapModelURL: bapURL };
};
export default useBapModelPageRoute;
